import { render, staticRenderFns } from "./direDeparView.vue?vue&type=template&id=71566910&scoped=true"
import script from "./direDeparView.vue?vue&type=script&lang=js"
export * from "./direDeparView.vue?vue&type=script&lang=js"
import style0 from "./direDeparView.vue?vue&type=style&index=0&id=71566910&prod&lang=scss&scoped=true"
import style1 from "./direDeparView.vue?vue&type=style&index=1&id=71566910&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71566910",
  null
  
)

export default component.exports